// Package imports:
import React from 'react';
import { SwiperSlide } from 'swiper/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faAngleRight } from '@fortawesome/free-solid-svg-icons';
// Component imports:
import Slider from '../Slider/Slider';
import Button from '../../ui-elements/Button/Button';
import TextImageBlock from '../TextImageBlock/TextImageBlock';
import Link from '../../ui-elements/Link/Link';
import ExcellentContactForm from '../ContactForms/ExcellentContactForm/ExcellentContactForm';
import DisplayBox from '../DisplayBox/DisplayBox';
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
import ExcellentSearch from './ExcellentSearch';

// To update:
// Update these numbers and imgSrc in TextImageBlock
const CURRENT_YEAR = 2023;
const PRICE = '89.900';
// Update this after list is published
const YEARS = [
    { year: 2022, companies: 1170},
    { year: 2021, companies: 1032 },
    { year: 2020, companies: 1109 },
    { year: 2019, companies: 1045 },
    { year: 2018, companies: 1165 },
    { year: 2017, companies: 863 }
];
// IMPORTANT: Search disclaimer needs to be shown before the list is ready and removed after publishing!

const ExcellentCompanies: React.FC = () => {
    return (
        <div className='main KCL_excellent-companies'>
            <div className="main__inner-fluid">
                <div>
                    <HeadSection
                        title="Fyrirmyndarfyrirtæki í rekstri"
                        description={
                            <p>Keldan í samstarfi við Viðskiptablaðið tekur saman lista á hverju rekstrarári yfir þau fyrirtæki sem teljast til fyrirmyndar í rekstri.</p>
                        }
                        actions={
                            <Button
                                size='lg'
                                buttonType='primary'
                                anchorProps={{href: '#vottun'}}
                            >
                                Panta vottun
                            </Button>
                        }
                        textAlign='center'
                    />

                    <div className="section__body">
                        <div className="shell">
                            <TextImageBlock
                                imgSrc="https://cdn.livemarketdata.com/Images/Fyrirmyndar/fyrirmyndarfyrirtaeki-2023.jpg"
                                imgSide="right"
                            >            
                                <h2 id="Excellent_CriteriaList">Hvað þarf til að teljast til fyrirmyndar?</h2>
                                <ul className="blue-dot-list">
                                    <li>Rekstrarárin {CURRENT_YEAR - 1} og {CURRENT_YEAR - 2} liggja til grundvallar en tekið er tillit til rekstrarársins {CURRENT_YEAR - 3}.</li>
                                    <li>Afkoma þarf að hafa verið jákvæð.</li>
                                    <li>Tekjur þurfa að hafa verið umfram 40 milljónir króna.</li>
                                    <li>Eignir þurfa að hafa verið umfram 80 milljónir króna.</li>
                                    <li>Eiginfjárhlutfall þarf að hafa verið umfram 20%.</li>
                                    <li>Aðrir þættir metnir af Viðskiptablaðinu og Keldunni. Til dæmis skil á ársreikningi og rekstrarform.</li>
                                </ul>
                                <div className='excellentSearchContainer'>
                                    <ExcellentSearch year={CURRENT_YEAR} />
                                </div>
                            </TextImageBlock>
                        </div>
                    </div>
                </div>

                <div className="section section--primary section--gray">
                    <div className="section__head">
                        <h2 id="Excellent_RecentYears">Viðurkenningar síðustu ára</h2>
                    </div>

                    <div className="section__body">
                        <div className="shell">
                                <div className="slid">
                                    <div className="desktop__version">
                                        <Slider
                                            className="slider-years"
                                            perView={4}
                                            centerSlides={false}
                                            loop={false}
                                            breakpointOptions={{
                                                320: {
                                                    slidesPerView: 1
                                                },
                                                768: {
                                                    slidesPerView: 3
                                                }
                                            }}
                                            onInit={() => {}}
                                            onSlideChange={() => {}}
                                        >
                                            {YEARS.map((year) => (
                                                <SwiperSlide
                                                    key={year.year}
                                                >
                                                    <DisplayBox title={`Árið ${year.year}`}>
                                                        <p>{year.companies} fyrirtæki fengu viðurkenninguna árið {year.year}.</p>
                                                        <Link url={`/Listar/Fyrirmyndarfyrirtaeki/${year.year}`} linkSize='14'>
                                                            <FontAwesomeIcon icon={faAngleRight} />
                                                            Skoða listann
                                                        </Link>
                                                    </DisplayBox>
                                                </SwiperSlide>
                                            ))}
                                        </Slider>
                                    </div>
                                    <div className="mobile__version">
                                        {YEARS.map((year) => (
                                            <DisplayBox title={`Árið ${year.year}`} key={year.year}>
                                                <p>{year.companies} fyrirtæki fengu viðurkenninguna árið {year.year}.</p>
                                                <Link url={`/Listar/Fyrirmyndarfyrirtaeki/${year.year}`} linkSize='14'>
                                                    <FontAwesomeIcon icon={faAngleRight} />
                                                    Skoða listann
                                                </Link>
                                            </DisplayBox>
                                        ))}
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>

                <div className="section section--contact" id="vottun">
                    <div className="shell">
                        <div className="section__inner">
                            <div className="section__head">
                                <h2 id="Excellent_Contact">Vottun fyrir fyrirmyndarfyrirtæki</h2>
                                <p>Þau fyrirtæki sem hljóta viðurkenninguna geta keypt vottun en með henni fylgir útprentað viðurkenningarskjal sem kjörið er til þess að hafa innrammað á sýnilegum stað á skrifstofu fyrirtækisins.</p>

                                <p className="list-heading">Með vottuninni fæst meðal annars:</p>

                                <ul className="list-option-checks">
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} className="icon-fa"/>
                                        Viðurkenningarskjal á íslensku og ensku
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} className="icon-fa"/>
                                        Leyfi til að nota merkið í kynningarefni.
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} className="icon-fa"/>
                                        Listi yfir fyrirmyndarfyrirtæki {CURRENT_YEAR} og lykiltölur.
                                    </li>
                                </ul>

                                <p className="price">Verð: {PRICE} kr. án vsk.</p>
                            </div>
                            <div className="section__body">
                                <div className='section__content form form--signup'>
                                    <ExcellentContactForm />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
        </div>
    )
}

export default ExcellentCompanies;